import script from "./EnglishDectionary.vue?vue&type=script&setup=true&lang=js"
export * from "./EnglishDectionary.vue?vue&type=script&setup=true&lang=js"

import "./EnglishDectionary.vue?vue&type=style&index=0&id=27c8a5fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c8a5fb"]])

export default __exports__